jQuery(document).ready(function($) {

    /* AJAX Basket Updater */

    var timeout;

    jQuery('div.woocommerce').on('change keyup mouseup', 'input.qty', function(){ // keyup and mouseup for Firefox support
        if (timeout != undefined) clearTimeout(timeout); //cancel previously scheduled event
        if (jQuery(this).val() == '') return; //qty empty, instead of removing item from cart, do nothing
        timeout = setTimeout(function() {
            jQuery('[name="update_cart"]').trigger('click');
        }, 500 );
    });

    /* AJAX Add to Cart */

    jQuery(function($) {

        $('form.cart.admin_edit').on('submit', function(e){
            // Allow admin edit forms to submit normally
            e.preventDefault(); // Prevent the default form submission
            var form = $(this);
            form.block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });

            var formData = new FormData(form[0]);
            formData.append('admin_submit', 1 );

            $.ajax({
                url: ajax_object.ajax_url,
                data: formData,
                type: 'POST',
                processData: false,
                contentType: false,
                success: function( response ) {
                    console.log(response);
                    form.unblock();
                }
            });
        });

        $('form.cart').on('submit', function(e) {
            e.preventDefault();
            if ($(this).hasClass('admin_edit')) {
                return;
            }

            // Check to see if this is an external product by checking the form method
            if( $(this).attr('method') === 'get' ) {
                window.location = $(this).attr('action');
                return;
            }

            var form = $(this);
            form.block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });

            var formData = new FormData(form[0]);
            formData.append('add-to-cart', form.find('[name=add-to-cart]').val() );

            // Ajax action.
            $.ajax({
                url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'add_to_cart' ),
                data: formData,
                type: 'POST',
                processData: false,
                contentType: false,
                complete: function( response ) {
                    response = response.responseJSON;

                    console.log(wc_add_to_cart_params);

                    if ( ! response ) {
                        return;
                    }

                    if ( response.error && response.product_url ) {
                        window.location = response.product_url;
                        return;
                    }

                    // Redirect to cart option
                    if ( wc_add_to_cart_params.cart_redirect_after_add === 'yes' || $('input[name="cart_item_key"]').length ) {
                        window.location = wc_add_to_cart_params.cart_url;
                        return;
                    }

                    var thisbutton = form.find('.single_add_to_cart_button');
                    
                    // Get the current add to cart text to compensate for translations
                    var addToCart = $('.single_add_to_cart_button').html(); 

                    // Trigger event so themes can refresh other areas.
                    $(document.body).trigger('added_to_cart', [ response.fragments, response.cart_hash, thisbutton ] );

                    // Remove existing notices
                    $('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();

                    // Get the translations for "Added" from a data attribute we've added to the single product page
                    $('.single_add_to_cart_button').html((addToCart ?? '') + ' <span class="icon-tick"></span>');
                    //block the button to prevent multiple clicks
                    $('.single_add_to_cart_button').prop('disabled', true);

					// Change button text after 4 seconds
                    setTimeout(function() {
						$('.single_add_to_cart_button').html(addToCart);
						$('.single_add_to_cart_button').prop('disabled', false);
					}, 4 * 1000);

                    form.unblock();
                }
            });
        });
        
        if ($('form.checkout').length) {

            $.ajax({
                url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_default_shipping_address' ),
                type: 'GET',
                success: function( response ) {
                    $.each(response, function(key, value) {
                        // Populate the corresponding shipping fields with the default values
                        var field = $('form.checkout').find('[name="' + key + '"]');
                        console.log('Populating field:', key, 'with value:', value);
                        if (field.length && value !== undefined && value !== "") {
                            field.val(value);
                            if (field.hasClass('select2-hidden-accessible')) {
                                field.val(value).trigger('change');
                            }
                        }
                    });
                }
            });
        }

    });

	jQuery(document).ready(function($){
		$('body').on( 'adding_to_cart', function(data, $thisbutton){
			$($thisbutton).parent().block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });
		});

		$('body').on( 'added_to_cart', function(event, fragments, cart_hash, button){
            updateCart();
            $(button).data('added', $(button).html());
			$(button).html(($(button).data('added') ?? '') + ' <span class="icon-tick"></span>');
			$(button).parent().unblock();

			// Change button text after 4 seconds
			setTimeout(function() {
				$(button).html($(button).data('added'));
                $(button).removeClass('added');
			}, 4 * 1000);
		});
        $('body').on( 'removed_from_cart', function(event, fragments, cart_hash, button){
            setTimeout(function() {
                updateCart();
            }, 500);
        });
        $('body').on( 'change', 'form.cart select.qty', function(event, fragments, cart_hash, button){
            console.log('Quantity changed');
        });
        //when updating cart qty, update the cart totals in the header
        $('body').on( 'change', '.wc-block-components-quantity-selector input', function(event, fragments, cart_hash, button){
            //run after a short delay to allow the cart to update
            setTimeout(function() {
                updateCart();
            }, 500);
        });
        $('body').on( 'click', '.wc-block-components-quantity-selector button', function(event, fragments, cart_hash, button){
            //run after a short delay to allow the cart to update
            setTimeout(function() {
                updateCart();
            }, 500);
        });

        $('body').on( 'click', '.wc-block-cart-item__remove-link', function(event, fragments, cart_hash, button){
            //run after a short delay to allow the cart to update
            setTimeout(function() {
                updateCart();
            }, 500);
        });
        
	});

    function updateCart() {
        $.ajax({
            url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_refreshed_fragments' ),
            type: 'POST',
            success: function( data ) {
                if ( data && data.fragments ) {
                    $.each( data.fragments, function( key, value ) {
                        // console.log(key, value);
                        $( key ).replaceWith( value );
                        if ( key.indexOf('.cart-header') !== -1 ) {
                            //parse the value as html and get the value from the '.cart-totals' element
                            var cartTotals = $(value).find('.cart-totals').html();
                            $('.basket-count').html(cartTotals);
                        }
                        if ( key.indexOf('.widget_shopping_cart_content') !== -1 ) {
                            var basketTotals = $(value).find('.total .amount').html();
                            $('.account-balance').html(basketTotals);
                        }
                    });
                }
            }
        });
    }

    updateCart();

    $('body').on('click', '#help', function(e) {
        var current_url = window.location.href;
        console.log(current_url);
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'get_help_content',
                url: current_url
            },
            success: function(response) {
                if (response.success) {
                    $('#help-modal .title').html('Help: ' + response.data.title);
                    $('#help-modal .content').html(response.data.content);
                    $('#help-modal').addClass('active');
                } else {
                    alert('No help content available for this page.');
                }
            },
            error: function() {
                alert('An error occurred while fetching help content.');
            }
        });
        e.preventDefault();
    });

    $('body').on('click', '.modal .close, button.close-modal', function(e) {
        if ($('#change-password-modal').is(':visible')) {
            //remove the ?action=change_password from the URL if present
            var current_url = window.location.href;
            var new_url = current_url.replace('?action=change_password', '');
            window.history.replaceState(null, '', new_url);
        }
        $(this).closest('.modal').removeClass('active');
        e.preventDefault();
    });

    //bind the escape key to close modals
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            if ($('#change-password-modal').is(':visible')) {
                //remove the ?action=change_password from the URL if present
                var current_url = window.location.href;
                var new_url = current_url.replace('?action=change_password', '');
                window.history.replaceState(null, '', new_url);
            }
            $('.modal.active').removeClass('active');
        }
    });

    $('body').on('click', '.update-customisation-details', function(e) {
        $('.pdf-brochure-wrapper .front').addClass('loading');
        $('.pdf-brochure-wrapper .back').addClass('loading');
        $('.product-customisation-downloads').removeClass('active');
        var form = $('form.cart').length ? $('form.cart') : null;
        if (!form) {
            return;
        }
        var formData = new FormData(form[0]);
        console.log(formData);
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                if (response.success) {
                    console.log(response.data);
                    $('.pdf-brochure-wrapper .front img').attr('src', response.data.refresh_url.front);
                    $('.pdf-brochure-wrapper .back img').attr('src', response.data.refresh_url.back);
                    if (typeof response.data.refresh_url.links !== 'undefined') {
                        if (response.data.refresh_url.links.pdf || response.data.refresh_url.links.word) {
                            $('.product-customisation-downloads').addClass('active');
                            if (response.data.refresh_url.links.pdf) {
                                $('.product-customisation-downloads ul li.pdf-version').addClass('active');
                                $('.product-customisation-downloads ul li.pdf-version a').attr('href', response.data.refresh_url.links.pdf);
                            } else {
                                $('.product-customisation-downloads ul li.pdf-version').removeClass('active');
                                $('.product-customisation-downloads ul li.pdf-version a').attr('href', '#');
                            }
                            if (response.data.refresh_url.links.word) {
                                $('.product-customisation-downloads ul li.word-version').addClass('active');
                                $('.product-customisation-downloads ul li.word-version a').attr('href', response.data.refresh_url.links.word);
                            } else {
                                $('.product-customisation-downloads ul li.word-version').removeClass('active');
                                $('.product-customisation-downloads ul li.word-version a').attr('href', '#');
                            }
                        }
                    }

                    $('.pdf-brochure-wrapper .front img').on('load', function() {
                        $('.pdf-brochure-wrapper .front').removeClass('loading');
                    });
                    $('.pdf-brochure-wrapper .back img').on('load', function() {
                        $('.pdf-brochure-wrapper .back').removeClass('loading');
                    });
                } else {
                    alert('An error occurred while saving customisation.');
                }
            },
            error: function() {
                alert('An error occurred while saving customisation.');
            }
        });
        e.preventDefault();
    }); 

    $('body').on('submit', '#product-customisation-form', function(e) {
        e.preventDefault();
        var form = $(this);
        var formData = new FormData(form[0]);
        console.log(formData);
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                if (response.success) {
                    console.log(response.data);
                    $('.pdf-brochure-wrapper img').attr('src', response.data.refresh_url);
                } else {
                    alert('An error occurred while saving customisation.');
                }
            },
            error: function() {
                alert('An error occurred while saving customisation.');
            }
        });
    });

    $('body').on('click', '.product-customisation-tabs .tab a', function(e) {
        var tab = $(this).parent('.tab').data('tab');
        $('.product-customisation-tabs .tab').removeClass('active');
        $(this).parent().addClass('active');
        $('.product-customisation-tabs .tab-content').removeClass('active');
        $('.product-customisation-tabs #' + tab).addClass('active');
        e.preventDefault();
    });

    $('.input-field-wrapper.type-select2 select').select2({
        escapeMarkup: function (text) { return text; },
        ajax: {
            url: ajax_object.ajax_url,
            dataType: 'json',
            delay: 250,
            data: function(params) {
                return {
                    action: 'get_select2_options',
                    field: $(this).attr('name'),
                    search: params.term
                };
            },
            processResults: function(data) {
                return {
                    results: data
                };
            },
            cache: true
        }
    });

});

jQuery(document).ready(function($) {
    if ($('.ck-editor').length > 0) {
        ClassicEditor
        .create(document.querySelector('.ck-editor'))
        .then(editor => {
            window.editor = editor;
            //remove all existing toolbar buttons
            editor.ui.view.toolbar.element.innerHTML = '';
            //trigger update of textarea
            editor.model.document.on('change:data', () => {
                //if we have content make the Add to cart button enabled
                if (editor.getData().trim() !== '') {
                    $('.single_add_to_cart_button').prop('disabled', false);
                } else {
                    $('.single_add_to_cart_button').prop('disabled', true);
                }
            });
        })
        .catch(error => {
            console.error(error);
        });
    }

    $('.single_add_to_cart_button').prop('disabled', true);

    if ($('.product-customisation-tabs input, .product-customisation-tabs select, .product-customisation-tabs textarea').length === 0 && $('#production_note').length === 0) {
        $('.single_add_to_cart_button').prop('disabled', false);
    }

    //check all fields in #product-customisation-form and enable/disable the add to cart button accordingly
    $('.product-customisation-tabs input, .product-customisation-tabs select, .product-customisation-tabs textarea, #production_note').on('input change', function() {
        var allFilled = true;
        $('.product-customisation-tabs input, .product-customisation-tabs select, .product-customisation-tabs textarea, #production_note').each(function() {
            if ($(this).val().trim() === '') {
                allFilled = false;
                return false;
            }
        });
        $('.product-customisation-tabs select').each(function() {
            if ($(this).val().trim() === '' || $(this).val().trim() === '-1') {
                allFilled = false;
                return false;
            }
        });
        $('.single_add_to_cart_button').prop('disabled', !allFilled);
    }).trigger('change');

    $('body').on('click', '.preview-bespoke-item', function(e) {
        e.preventDefault();
        var cartItemKey = $(this).data('cart-item');
        console.log('Preview bespoke item clicked for cart item:', cartItemKey);
        // You can add your preview logic here, e.g., open a modal with the preview
        window.open(ajax_object.home_url + '/?action=preview_bespoke_item=1&cart_item_key=' + cartItemKey, '_blank');
    });

    const event = new CustomEvent( 'wc-blocks_added_to_cart', {
        detail: { preserveCartData: false } // false forces the blocks to pull fresh data
    });

    // jQuery('body').on('wc_fragments_loaded', function(e){
    //     console.log('Refreshing WooCommerce store notices');
    //     $.ajax({
    //             url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_refreshed_fragments' ),
    //             type: 'POST',
    //             data: {
    //                 action: 'refresh_store_notices'
    //             },
    //             success: function(response) {
    //                 console.log('Response from refreshing store notices:', response);
    //                 console.log('Store notices refreshed');
    //             }
    //     });
    //     // now.do.whatever();
    // });

    $('body').on('click', '.confirm-bespoke-item', function(e) {
        const _this = $(this);
        e.preventDefault();
        var cartItemKey = $(this).data('cart-item');
        console.log('Confirm bespoke item clicked for cart item:', cartItemKey);
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'confirm_bespoke_item',
                cart_item_key: cartItemKey
            },
            processData: true,
            contentType: 'application/x-www-form-urlencoded',
            success: function(response) {
                if (response.success) {
                    $('[name=update_cart]').trigger('click');
                    $.ajax({
                        url: ajax_object.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'get_approval_status_html',
                            cart_item_key: cartItemKey
                        },
                        processData: true,
                        contentType: 'application/x-www-form-urlencoded',
                        success: function(response) {
                            if (response.success) {
                                _this.closest('.wc-block-components-product-details__value').html(response.data.approval_status_html);
                                var numButtons = $('.wc-block-components-button.confirm-bespoke-item').length;
                                if (numButtons === 0) {
                                    $('.wc-block-components-notice-banner.is-error').remove();
                                } else {
                                    //refresh woocommerce store notices
                                    
                                }
                                // $( document.body ).trigger( 'wc_fragments_loaded' );
                            }
                        }
                    });
                } else {
                    alert('An error occurred while confirming the bespoke item.');
                }
            },
            error: function() {
                alert('An error occurred while confirming the bespoke item.');
            }
        });
    });
    $('#account-request').on('submit', function(e) {
        e.preventDefault();
        var formData = $(this).serialize();
        $('.error-message').remove();
        $('.field').removeClass('has-error');
        //submit to admin-post.php
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: formData,
            processData: true,
            contentType: 'application/x-www-form-urlencoded',
            success: function(response) {
                if (response.success) {
                    console.log(response);
                    //handle the successful response
                    $('#account-request').before('<p class="success-message">' + response.data.message + '</p>');
                    $('#account-request').remove();

                } else {
                    //handle the error response
                    if (response.data.errors && Object.keys(response.data.errors).length > 0) {
                        $.each(response.data.errors, function(field, message) {
                            console.log(field + ': ' + message);
                            $('[name=' + field + ']').parents('.field').addClass('has-error');
                            $('[name=' + field + ']').after('<span class="error-message">' + message + '</span>');
                            $('[name=' + field + ']').on('input', function() {
                                $(this).next('.error-message').remove();
                                $(this).parents('.field').removeClass('has-error');
                            });
                        });
                    } else {
                        $('#account-request').before('<p class="error-message">' + response.data.message + '</p>');
                    }
                }
            },
            error: function(response) {
                //handle the error response
                console.log(response.responseText);
            }
        });
    });

    $('#personal-details').on('submit', function(e) {
        e.preventDefault();
        var formData = $(this).serialize();
        $('.error-message').remove();
        $('.field').removeClass('has-error');

        //handle before submitting the form, request any necessary pre-approval checks


        //submit to admin-post.php
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: formData,
            processData: true,
            contentType: 'application/x-www-form-urlencoded',
            success: function(response) {
                if (response.success) {
                    console.log(response);
                    //handle the successful response
                    $('#personal-details').before('<p class="success-message">' + response.data.message + '</p>');
                } else {
                    //handle the error response
                    if (response.data.errors && Object.keys(response.data.errors).length > 0) {
                        $.each(response.data.errors, function(field, message) {
                            console.log(field + ': ' + message);
                            $('[name=' + field + ']').parents('.field').addClass('has-error');
                            $('[name=' + field + ']').after('<span class="error-message">' + message + '</span>');
                            $('[name=' + field + ']').on('input', function() {
                                $(this).next('.error-message').remove();
                                $(this).parents('.field').removeClass('has-error');
                            });
                        });
                    } else if (response.data.requires_user_approval) {
                        //create a modal asking for the users current password to approve the account
                    } else {
                        $('#personal-details').before('<p class="error-message">' + response.data.message + '</p>');
                    }
                }
            },
            error: function(response) {
                //handle the error response
                $('#personal-details').before('<p class="error-message">' + response.responseText + '</p>');
            }
        });
    });

    $('#change-password-form').on('submit', function(e) {
        e.preventDefault();
        var formData = $(this).serialize();

        $('.error-message').remove();
        $('.field').removeClass('has-error');

        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: formData,
            processData: true,
            contentType: 'application/x-www-form-urlencoded',
            success: function(response) {
                if (response.success) {
                    //redirect the user to the login page after changing the password
                    window.location.href = response.data.login_url;
                } else {
                    //handle the error response
                    if (response.data.errors && Object.keys(response.data.errors).length > 0) {
                        $.each(response.data.errors, function(field, message) {
                            console.log(field + ': ' + message);
                            $('[name=' + field + ']').parents('.field').addClass('has-error');
                            $('[name=' + field + ']').after('<span class="error-message">' + message + '</span>');
                            $('[name=' + field + ']').on('input', function() {
                                $(this).next('.error-message').remove();
                                $(this).parents('.field').removeClass('has-error');
                            });
                        });
                    } else {
                        $('#change-password-form').before('<p class="error-message">' + response.data.message + '</p>');
                    }
                }
            },
            error: function(response) {
                //handle the error response
                $('#change-password-form').before('<p class="error-message">' + response.responseText + '</p>');
            }
        });
    });

    $('body').on('click', 'a.change-password-link', function(e) {
        e.preventDefault();
        //handle the change password link click, e.g., show a modal for changing password
        //use the history api to append the url but dont save it in the back history
        history.replaceState(null, '', $(this).attr('href'));
        $('#change-password-modal').addClass('active');
    });
});